import React from 'react';

/* Components */
import ConversionFlowDatalayer from './ConversionFlowDatalayer';
import ConversionFlowOverlay from './ConversionFlowOverlay';
import ConversionFlowForm from './ConversionFlowForm';

export default function ConversionFlow({ open, handleClose, flowUrl, usps, uspsLease, addConversionParam, sourceFlow, vehicle, datalayerData, form }) {
    return (
        <ConversionFlowOverlay
            open={open}
            handleClose={handleClose}
            flowUrl={flowUrl}
            usps={usps}
            addConversionParam={addConversionParam}
            sourceFlow={sourceFlow}
            overlayBody={(passProps) => {
                const { flow } = passProps;
                return (
                    <>
                        <ConversionFlowDatalayer activeStepId={flow?.steps?.find((step) => step.active)?.id} flow={flow} datalayerData={datalayerData} />
                        <ConversionFlowForm
                            {...passProps}
                            vehicle={vehicle}
                            uspsLease={uspsLease}
                            form={form}
                            handleClose={handleClose}
                        />
                    </>
                )
            }}
        />
    )
}
